const TERMINAL_EVENT_STATES = ['canceled', 'closed', 'archive']

export const canHostClosePlayableEvent = (playableEvent, isHostingPlayableEvent) => {
  if (typeof isHostingPlayableEvent !== 'function' || !isHostingPlayableEvent(playableEvent)) {
    return false
  }

  const state = String(playableEvent?.anearEvent?.state || '').toLowerCase()
  return !TERMINAL_EVENT_STATES.includes(state)
}

/** API transition target: live → closed; everything else actionable → canceled */
export const hostCloseTransitionState = (anearEvent) => {
  const state = String(anearEvent?.state || '').toLowerCase()
  return state === 'live' ? 'closed' : 'canceled'
}

export const getHostEndEventPresentation = (anearEvent) => {
  const transitionState = hostCloseTransitionState(anearEvent)
  const eventState = String(anearEvent?.state || '').toLowerCase()
  const isEndingLive = transitionState === 'closed'

  if (isEndingLive) {
    return {
      transitionState,
      tone: 'close',
      actionLabel: 'Close',
      actionLabelCaps: 'CLOSE',
      ariaLabel: 'Close live event',
      icon: 'stop'
    }
  }

  const isAnnounced = eventState === 'announce'
  return {
    transitionState,
    tone: 'cancel',
    actionLabel: 'Cancel',
    actionLabelCaps: 'CANCEL',
    ariaLabel: isAnnounced ? 'Cancel announced event' : 'Cancel event before going live',
    icon: 'cancel'
  }
}

export const hostCloseConfirmationCopy = (transitionState, eventTitle, eventState = '') => {
  const title = eventTitle || 'Event'
  const normalizedState = String(eventState || '').toLowerCase()

  if (transitionState === 'closed') {
    return {
      confirmTitle: `Close ${title}?`,
      confirmBody: 'This ends the live event for everyone. Participants will no longer be able to play.',
      stayLabel: 'Keep Live',
      exitLabel: 'Close Event'
    }
  }

  const announceHint = normalizedState === 'announce'
    ? 'This event is announced but not live yet.'
    : 'This event has not gone live yet.'

  return {
    confirmTitle: `Cancel ${title}?`,
    confirmBody: `${announceHint} Canceling is permanent and removes it from playables.`,
    stayLabel: 'Keep Event',
    exitLabel: 'Cancel Event'
  }
}
